<template>
  <div class="dashboard-block">
    <h2>Payment</h2>

    <form>
      <div class="row row-clear-md-4">
        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateCommissionRate, 'form-group')">
            <label class="control-label">{{ clientName }} Commission</label>
            <div class="input-group">
              <input
                name="commission_rate"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateCommissionRate.$model">
              <span class="input-group-addon"><i class="fa fa-percent"></i></span>
            </div>

            <vuelidate-help label="Commission rate" :field="$v.stateCommissionRate"/>
          </div>
        </div>
        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateDepositPayment, 'form-group')">
            <label class="control-label">Deposit payment</label>
            <div class="input-group">
              <input
                name="deposit_payment"
                type="number"
                class="form-control"
                v-model.lazy="$v.stateDepositPayment.$model">
              <span class="input-group-addon"><i class="fa fa-percent"></i></span>
            </div>

            <vuelidate-help label="Deposit payment" :field="$v.stateDepositPayment"/>
          </div>
        </div>
        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateNotificationEmail, 'form-group')">
            <label class="control-label">Notification Email</label>
            <input
              name="notification_email"
              type="email"
              class="form-control"
              v-model.lazy="$v.stateNotificationEmail.$model">

            <vuelidate-help label="Notification email" :field="$v.stateNotificationEmail"/>
          </div>
        </div>
        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateNotificationPhone, 'form-group')">
            <label class="control-label">Notification Phone</label>
            <input
              name="notification_phone"
              type="text"
              class="form-control"
              v-model.lazy="$v.stateNotificationPhone.$model">

            <vuelidate-help label="Notification phone" :field="$v.stateNotificationPhone"/>
          </div>
        </div>
        <div class="col-md-4">
          <div :class="$hasErrorClass($v.stateInvoiceTemplate, 'form-group')">
            <label class="control-label">Talent Invoice Template</label>
            <input
              name="talent_invoice_template"
              type="text"
              class="form-control"
              v-model.lazy="$v.stateInvoiceTemplate.$model">

            <vuelidate-help label="Invoice template" :field="$v.stateInvoiceTemplate"/>
          </div>
        </div>
      </div>

      <ladda-button
        class="btn btn-success"
        :click="handleSavePaymentSettingsCallback">
        <i class="fa fa-check"></i> Save Changes
      </ladda-button>
    </form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/settings'
import { pick } from 'lodash'
import VuelidateHelp from '../misc/VuelidateHelp'
import { notify } from 'utils'

export default {
  mixins: [stateMapper],

  components: { VuelidateHelp },

  validations: {
    stateCommissionRate: {
      required
    },
    stateDepositPayment: {
      required
    },
    stateNotificationEmail: {
      required,
      email
    },
    stateNotificationPhone: {
      required
    },
    stateInvoiceTemplate: {}
  },

  methods: {
    ...mapActions('settings', ['updateSettings']),

    handleSavePaymentSettingsCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }
      return this.updateSettings(pick(this.settings, [
        'commission_rate',
        'deposit_payment',
        'notification_email',
        'notification_phone',
        'talent_invoice_template'
      ]))
    }
  }
}
</script>
